import { useState } from "react";
import { Form } from "react-bootstrap";

export const FormTextArea = (param) => {
  const [value, setValue] = useState(null);

  return (
    <Form.Group className={param.className} controlId={param.id}>
      <Form.Label>{param.label}</Form.Label>
      <Form.Control
        as={"textarea"}
        rows={5}
        className="input-placeholder"
        placeholder={param.placeholder}
        name={param.name}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        {...param.control}
        style={{
          backgroundColor: "transparent",
          color: "white",
        }}
      />
    </Form.Group>
  );
};

export default FormTextArea;
